import React from "react";

const NotFound = () => {
  //  center style
  const textAlign = { textAlign: "center" };

  return (
    <div style={textAlign}>The requested URL was not found on this server.</div>
  );
};

export default NotFound;
